import React from "react";
import {
  BsCameraVideoFill,
  BsMicFill,
  BsCheckCircleFill,
  BsXCircleFill,
} from "react-icons/bs";
import { FaChrome, FaNetworkWired } from "react-icons/fa";
import { MdRefresh } from "react-icons/md";
import { IoWarning } from "react-icons/io5";

const SystemStatus = ({
  isChecking,
  hasCamera,
  hasMicrophone,
  deviceError,
  checkDevices,
}) => {
  return (
    <div className="status-section devices">
      <h3>System Requirements</h3>
      <div className="session-info">
        {isChecking ? (
          <div className="checking-status">
            <div className="loading-spinner"></div>
            <p>Checking devices...</p>
          </div>
        ) : (
          <>
            <div className="device-status-container">
              <div className="device-status">
                <p>
                  <span
                    className={`status-icon ${hasCamera ? "success" : "error"}`}
                  >
                    {hasCamera ? <BsCheckCircleFill /> : <BsXCircleFill />}
                  </span>
                  <BsCameraVideoFill className="device-icon" />
                  Camera: {hasCamera ? "Available" : "Not available"}
                </p>
                {hasCamera && (
                  <span className="device-info">HD Camera Ready</span>
                )}
              </div>
              <div className="device-status">
                <p>
                  <span
                    className={`status-icon ${
                      hasMicrophone ? "success" : "error"
                    }`}
                  >
                    {hasMicrophone ? <BsCheckCircleFill /> : <BsXCircleFill />}
                  </span>
                  <BsMicFill className="device-icon" />
                  Microphone: {hasMicrophone ? "Available" : "Not available"}
                </p>
                {hasMicrophone && (
                  <span className="device-info">Audio Input Ready</span>
                )}
              </div>
              <div className="device-status">
                <p>
                  <span className="status-icon success">
                    <BsCheckCircleFill />
                  </span>
                  <FaChrome className="device-icon" />
                  Browser: Compatible
                </p>
                <span className="device-info">
                  Chrome {navigator.userAgent.match(/Chrome\/([0-9.]+)/)?.[1]}
                </span>
              </div>
              <div className="device-status">
                <p>
                  <span className="status-icon success">
                    <BsCheckCircleFill />
                  </span>
                  <FaNetworkWired className="device-icon" />
                  Network: Connected
                </p>
                <span className="device-info">Stable Connection</span>
              </div>
            </div>
            {deviceError && (
              <div className="device-error">
                <IoWarning className="error-icon" />
                <p>{deviceError}</p>
              </div>
            )}
            <div className="button-container">
              <button className="retry-button" onClick={checkDevices}>
                <MdRefresh className="button-icon" /> Retry Device Check
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SystemStatus;
